module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00063.0ecd0e1f.jpg";